import { __rest } from 'tslib';
import React from 'react';
import Icon from '@ant-design/icons';
import { I as IconBase } from '../IconBase-df74767e.js';

const IconComponent = (props, ref) => {
    const data = {
        tag: 'svg',
        attr: { viewBox: '0 0 24 24', fill: 'none' },
        child: [
            {
                tag: 'path',
                attr: {
                    fillRule: 'evenodd',
                    clipRule: 'evenodd',
                    d: 'M12.0021 2.00024C8.91306 1.97874 6.03666 3.4038 4.1789 5.77736L3.73366 3.15168C3.6644 2.7433 3.2772 2.46838 2.86882 2.53763C2.46044 2.60688 2.18552 2.99408 2.25477 3.40246L3.0255 7.94755C3.06065 8.18296 3.20702 8.39776 3.43683 8.51062C3.59177 8.58671 3.76018 8.60445 3.91715 8.57236L8.45281 7.80323C8.8612 7.73398 9.13612 7.34678 9.06687 6.93839C8.99761 6.53001 8.61041 6.25509 8.20203 6.32434L5.268 6.82187C6.8393 4.73746 9.32297 3.48089 11.994 3.50022V3.50024H11.9994C16.6935 3.50024 20.4988 7.30555 20.4988 11.9996C20.4988 16.6937 16.6935 20.4991 11.9994 20.4991C7.30532 20.4991 3.5 16.6937 3.5 11.9996C3.5 11.5854 3.16421 11.2496 2.75 11.2496C2.33579 11.2496 2 11.5854 2 11.9996C2 17.5222 6.47689 21.9991 11.9994 21.9991C17.5219 21.9991 21.9988 17.5222 21.9988 11.9996C21.9988 6.47803 17.5234 2.0017 12.0021 2.00024ZM14.5087 9.29195H15.3574V8.30904H14.5087V7.58395H12.9511V8.30904H11.5976V9.29195H12.9511V10.5488C12.5823 10.1263 12.115 9.915 11.5493 9.915C10.8439 9.915 10.2871 10.1836 9.87885 10.7207C9.47423 11.2578 9.27191 11.9793 9.27191 12.8852C9.27191 13.8449 9.47781 14.595 9.88959 15.1357C10.305 15.6728 10.8546 15.9414 11.5385 15.9414C12.1472 15.9414 12.645 15.6997 13.0317 15.2163L13.1069 15.8339H14.5087V9.29195ZM11.1088 14.2495C10.9191 13.9594 10.8242 13.5423 10.8242 12.998C10.8242 11.7841 11.1983 11.1772 11.9467 11.1772C12.423 11.1772 12.7578 11.3795 12.9511 11.7841V14.0776C12.7542 14.4822 12.4158 14.6845 11.936 14.6845C11.5743 14.6845 11.2986 14.5395 11.1088 14.2495Z',
                    fill: '#82869E',
                },
            },
        ],
    };
    const { style } = props;
    const _a = style || {}, { fontSize, color: passColor } = _a, rest = __rest(_a, ["fontSize", "color"]);
    const size = fontSize || 16;
    const color = passColor;
    return (React.createElement(Icon, Object.assign({}, props, { style: rest, ref: ref, component: () => (React.createElement(IconBase, { color: color, size: size, data: data, overrideColor: true })) })));
};
const RefundOutlined = React.forwardRef(IconComponent);
RefundOutlined.displayName = 'RefundOutlined';

export { RefundOutlined };
